// Helper functions for Devices Module
import { normalizeStatusId } from "../../../../../../utils/getStatusEntity";

export const getStatusColor = (status: { id: string; name: string }) => {
  if (!status) return "text-gray-500 bg-gray-500/10";

  // Normalize status ID to handle multiple formats (8/R5tW0uX4yY9cF6dH2aI8, etc.)
  const canonicalName = normalizeStatusId(status.id) || status.name;

  switch (canonicalName) {
    case "ACTIVE":
      return "text-green-500 bg-green-500/10";
    case "INACTIVE":
      return "text-red-500 bg-red-500/10";
    case "NO_DATA":
      return "text-orange-500 bg-orange-500/10";
    // Legacy statuses (fallback)
    case "Facturable":
      return "text-primary-500 bg-primary-500/10";
    default:
      return "text-gray-500 bg-gray-500/10";
  }
};

export const getStatusLabel = (
  status: { id: string; name: string },
  t?: (key: string, options?: any) => string,
) => {
  if (!status) return t ? t("statuses.unknown", "Desconocido") : "Desconocido";

  // Normalize status ID to handle multiple formats
  const canonicalName = normalizeStatusId(status.id) || status.name;

  if (t) {
    return t(`statuses.${canonicalName}`, canonicalName);
  }
  return canonicalName;
};

export const getDevicePrefix = (type: string) => {
  switch (type) {
    case "gps":
      return "GPS";
    case "phone":
      return "PH";
    case "bluetooth":
      return "BT";
    case "internal":
      return "IT";
    default:
      return "DV";
  }
};

export const getDeviceIcon = (type: string) => {
  switch (type) {
    case "gps":
      return {
        icon: "ri-map-pin-line",
        bgColor: "bg-primary-500/10",
        textColor: "text-primary-500",
      };
    case "phone":
      return {
        icon: "ri-smartphone-line",
        bgColor: "bg-blue-500/10",
        textColor: "text-blue-500",
      };
    case "bluetooth":
      return {
        icon: "ri-bluetooth-line",
        bgColor: "bg-blue-500/10",
        textColor: "text-blue-500",
      };
    case "internal":
      return {
        icon: "ri-cpu-line",
        bgColor: "bg-orange-500/10",
        textColor: "text-orange-500",
      };
    default:
      return {
        icon: "ri-device-line",
        bgColor: "bg-gray-500/10",
        textColor: "text-gray-500",
      };
  }
};

export const getDeviceTypeLabel = (
  type: string,
  t?: (key: string, options?: any) => string,
) => {
  if (t) {
    return t(`devices.type.${type}`, type);
  }
  switch (type) {
    case "gps":
      return "GPS";
    case "phone":
      return "Teléfono";
    case "bluetooth":
      return "Bluetooth";
    case "internal":
      return "Interno";
    default:
      return "Desconocido";
  }
};
